import { Group } from "@/models/feature/feature";

export type GroupSortBy = "name" | "memberCount";

/**
 * Danish collation, so Æ/Ø/Å sort after Z rather than next to A/O. The groups list is
 * held in full on the client, so unlike the user list this sorts locally.
 */
const compareDanish = (a: string, b: string): number =>
  a.localeCompare(b, "da", { sensitivity: "base" });

export const sortGroups = (
  groups: Group[],
  sortBy: GroupSortBy,
  ascending: boolean
): Group[] => {
  const direction = ascending ? 1 : -1;

  return [...groups].sort((a, b) => {
    if (sortBy === "memberCount") {
      const byCount = a.userIds.length - b.userIds.length;
      if (byCount !== 0) return byCount * direction;
      return compareDanish(a.name, b.name);
    }

    return compareDanish(a.name, b.name) * direction;
  });
};
